/**
 * Query params appended when a hosted-page CIT payment fails after a gateway redirect (3DS, etc.).
 */
export function parseHostedPaymentReturn(searchParams) {
  const status = searchParams.get("status")?.toLowerCase();
  const trxId = searchParams.get("trx_id");
  if (status !== "failed" || !trxId) return null;
  return { status, trxId };
}

/** Remove gateway return params so refresh does not re-process the decline UX. */
export function clearHostedPaymentReturnParams() {
  const url = new URL(window.location.href);
  ["trx_id", "status", "cko-session-id", "cko_session_id"].forEach((key) =>
    url.searchParams.delete(key)
  );
  const search = url.searchParams.toString();
  const next = url.pathname + (search ? `?${search}` : "");
  window.history.replaceState({}, "", next);
}
